export default "__VITE_ASSET___xLUyc6d__"